<div class="flex-1 flex flex-row justify-start items-stretch flex-wrap full-width">
  <div
    class="field is-empty payment-card full-width w-full"
    id="card-element"
    [ngClass]="{ 'error-field': subServ.cardError }"
    >
    :
  </div>
  @if (subServ.cardError) {
    <div class="tc-red-500 w-full card-hint">
      {{ subServ.cardError }}
    </div>
  }
  @if (profServ.latestProfile?.subscription_card_declined) {
    <div
      class="tc-red-500 w-full card-hint"
      >
      {{ "CARD_ON_FILE_NOT_VALID" | translate }}
    </div>
  }
</div>
